import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { addDisplayName } from "../Infra/display-name";
import { LoadingPlaceholder } from "./LoadingPlaceholder";
import { useViewModel } from "./useViewModel";
import { FastenCallbackViewModel } from "./FastenCallbackViewModel";
export const FastenCallbackView = observer((props) => {
    const model = useViewModel(FastenCallbackViewModel, props.container);
    return _jsx(LoadingPlaceholder, { w: 10, h: 60 });
});
addDisplayName(FastenCallbackView, "FastenCallbackView");
